import * as Immutable from "immutable";
import { validateResponseMessageURL } from "services/strings";
import BaseMessageRecord from "../BaseMessageRecord";

/**
 * @class LinkMessageRecord
 * @augments BaseMessageRecord
 */
class LinkMessageRecord extends BaseMessageRecord({
  type: "link",

  /**
   * @memberof LinkMessageRecord#
   */
  altText: "",
  linkText: "",
  generateLinkPreview: true,
  newWindow: true,
  title: "",
  linkIcon: "",
  linkDescription: "",
  isHandoff: false,
  url: ""
}) {}

/**
 * Validation
 */

/**
 * @param {LinkMessageRecord} message
 * @returns {Immutable.List.<String>}
 */
LinkMessageRecord.getInvalidFields = (message) => {
  const invalidFields = new Set();

  if (!validateResponseMessageURL(message.url)) {
    invalidFields.add("url");
  }

  return Immutable.List(invalidFields);
};

export default LinkMessageRecord;
